import type { Seconds } from '@lemonade-hq/ts-helpers';
import type { MotionNodeOptions } from 'motion/react';

interface PageAnimationProps {
  readonly delay?: number;
}

export const PAGE_ANIMATION_DURATION: Seconds = 0.5;

export function getPageAnimation({ delay }: PageAnimationProps = {}): MotionNodeOptions {
  return {
    initial: {
      opacity: 0,
      y: 20,
    },
    animate: {
      opacity: 1,
      y: 0,
      transition: { duration: PAGE_ANIMATION_DURATION, delay },
    },
    exit: {
      opacity: 0,
      y: 20,
    },
  };
}
